function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Math, Object, String, focus, value) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          inline: $attr(`inline`),
          focus
        }, {
          'text-editor': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("textarea", {
          "attrs": {
            placeholder: $attr(`placeholder`),
            rows: $helpers.getNumRows(),
          },
          "on": {
            input: $helpers.handleInput,
            keyup: $helpers.handleKeyUp,
            focus: $helpers.handleFocus,
            blur: $helpers.handleBlur,
          },
          "props": {
            value,
          },
          "hook": {
            insert: ({
              elm
            }) => $component.setElRef('textarea', elm),
          },
        }));
        __jade_nodes = __jade_nodes.concat((!($attr('hide-footer'))) ? ((function() {
          var __jade_nodes = [];
          const charactersRemaining = $helpers.charactersRemaining();
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'text-editor-footer': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": Object.assign({}, {
                'too-many-characters': charactersRemaining < 0
              }, {
                'characters-remaining': true
              }),
            }, [__vjadeSafeCode(`${charactersRemaining} ${$helpers.pluralize('character', Math.abs(charactersRemaining))} remaining`)]));
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "on": {
                click: $helpers.cancelChanges
              },
              "attrs": {
                size: 'small'
              },
              "class": {
                'mp-button-secondary': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Cancel");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "on": {
                click: $helpers.saveChanges
              },
              "attrs": {
                size: 'small',
                disabled: !$helpers.hasValidInput() && !$helpers.allowEmptySave()
              },
              "class": {
                'mp-button-primary': true,
                'save-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Save");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Math" in locals ? locals.Math : typeof Math !== "undefined" ? Math : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "focus" in locals ? locals.focus : typeof focus !== "undefined" ? focus : undefined, "value" in locals ? locals.value : typeof value !== "undefined" ? value : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;